<template>
	<div id="app">
		<keep-alive><router-view></router-view></keep-alive>
	</div>
</template>

<script type="text/javascript">
	export default {
		name: 'app',
		mounted () {  
			var _mtac = {};
		    var mta = document.createElement("script");
    		mta.src = "https://pingjs.qq.com/h5/stats.js?v2.0.2";
    		mta.setAttribute("name", "MTAH5");
    		mta.setAttribute("sid", "500507542");
    		var s = document.getElementsByTagName("script")[0];
    		s.parentNode.insertBefore(mta, s);  
		},  
		watch: {  
	      '$route' () {  
	        if (window._czc) {  
	        		let location = window.location  
	        		let contentUrl = location.pathname + location.hash  
	        		let refererUrl = '/' 
	        		window._czc.push(['_trackPageview', contentUrl, refererUrl])  
	      		}  
	    	}  
	  	}  
	}

</script>

<style lang="scss">
	body {
		margin: 0px;
		padding: 0px;
		background: white;
		font-family: Helvetica Neue, Helvetica,Arial,PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif !important;
		font-size: 14px;
		-webkit-font-smoothing: antialiased;
	}
	
	#app {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
	}
	
	/* .el-submenu [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}
	
	.el-menu-item [class^=fa] {
		vertical-align: baseline;
		margin-right: 10px;
	}
	
	.toolbar {
		background: #fff;
		padding: 10px;
		.el-form-item {
			margin-bottom: 10px;
		}
	} */
</style>


// WEBPACK FOOTER //
// App.vue?1a78eb86